import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';

import Collapse from '@material-ui/core/Collapse';
import VoltageList from './listItemVoltage';

//const voltageList = ['35', '110', '220', '400'];

export class RegionListItem extends Component {

    state = {
        open: false,
        checked: true
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(!this.compareLists(this.props.ohlList, nextProps.ohlList) 
            //|| !this.compareLists(this.props.checkedOhlsList, nextProps.checkedOhlsList) 
            || this.props.parentChecked !== nextProps.parentChecked 
            || this.state !== nextState){
            return true;
        }
        else{
            return false; 
        }
    }

    compareLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if(list1.length !== list2.length){
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps){

        if(prevProps.parentChecked !== this.props.parentChecked){
            this.setState({
                checked: this.props.parentChecked
            });
        }
    }

    onToogleOpen = () => {
        this.setState((previousState) => ({
            open: !previousState.open
        }));
    }

    onToogleRegionChecked = (e) => {
        this.setState((previousState) => ({
            checked: !previousState.checked
        }));
        this.props.onToogleOhlsChecked(this.props.ohlList.map(ohl => ohl.name), e.target.checked);
    }

    render() {

        let voltageList = [...new Set(this.props.ohlList.map(ohl => ohl.voltage))];

        return (
            <List>
                <div >
                    <ListItem  key={this.props.name} >
                        <ListItemText secondary={this.props.name} />
                        {this.props.isSelectable ? <Checkbox style={{marginRight: '10px'}}
                            checked={this.state.checked}
                            onChange={(e) => this.onToogleRegionChecked(e, this.props.name)}
                            color='primary'
                        /> : null}
                        {this.state.open ? <ExpandLess onClick={this.onToogleOpen} /> : <ExpandMore onClick={this.onToogleOpen} />}
                    </ListItem>
                    <Collapse in={this.state.open} timeout="auto" >
                    {this.props.ohlList && this.props.ohlList.length > 0 ? 
                        <List component="div" key={this.props.name}  style={{marginLeft: '25px'}}>
                            {voltageList.map((v, index) => ( 
                                this.props.ohlList.filter(ohl => ohl.voltage === v).length > 0 ? 
                                    <span key={index} > 
                                        <VoltageList 
                                            key={index} 
                                            voltage={v} 
                                            //checkedOhlsList={this.props.ohlList.filter(ohl => ohl.voltage === v)} 
                                            ohlList={this.props.ohlList.filter(ohl => ohl.voltage === v)}
                                            onToogleOhlChecked={(ohl, isChecked) => this.props.onToogleOhlChecked(ohl, isChecked) } 
                                            onToogleOhlsChecked={this.props.onToogleOhlsChecked}
                                            centerOHLByName={this.props.centerOHLByName}
                                            //centerOHLById={this.props.centerOHLById}
                                            parentChecked={this.state.checked}
                                            isSelectable={this.props.isSelectable}
                                        /> 
                                    </span>
                                : null                          
                            ))}
                        </List>
                        : null}
                    </Collapse>
                </div>
            </List>
        )
    }
}


export default RegionListItem;

